<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center">Service Requests</h3>
        </v-flex>
        <v-flex xs12 md8 sm11>
          <v-card>
            <v-card-text>
              <v-data-table dense :items="service_requests" :headers="headers">
                <template v-slot:[`item.id`]="{ item }">
                  <inertia-link :href="'/user/requests/' + item.id">{{ moment(item.created_at).format('dddd MMMM D, yyyy H:m') }}</inertia-link>
                </template>
                <template v-slot:[`item.visit_id`]="{ item }">
                  <v-icon v-if="item.visit_id" title="Yes">mdi-sticker-check-outline</v-icon>
                  <span v-else>No</span>
                </template>
                <template v-slot:[`item.cancel`]="{ item }">
                  <v-btn small title="Cancel Request" @click="cancelRequest(item)" v-if="!item.visit_id || !item.professional_id" color="red">Cancel</v-btn>
                </template>
                <template v-slot:[`item.cost`]="{ item }">
                  <span>{{ item.cost ? item.cost.format(2) : item.cost }}</span>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/User'

  export default {
    name: 'ServiceRequests',
    layout,
    props: [
      'service_requests', 'client'
    ],
    data () {
      return {
        headers: [
          {
            text: 'View', value: 'id'
          },
          {
            text: 'Package', value: 'package.name'
          },
          {
            text: 'Cost', value: 'cost', align: 'right'
          },
          {
            text: 'Visited', value: 'visit_id'
          },
          {
            text: '', value: 'cancel'
          }
        ]
      }
    },
    methods: {
      cancelRequest (request) {
        swal({
          title: '',
          text: 'Do you want to cancel request?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Yes! Cancel',
          cancelButtonText: 'No! Never mind'
        },
        function () {
          this.$inertia.delete('/service_requests/' + request.id, {
            preserveScroll: true,
            onSuccess: () => {
              swal({ title: 'Cancelled!', type: 'success', timer: 2500 })
            }
          })
        }.bind(this))
      },
    },
  }
</script>

<style>
   /**/
</style>
